import { logQueryError } from '@infl-ts/util-query-errors';
import { Box, Divider, Typography } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import * as A from 'fp-ts/Array';
import { constNull, flow, pipe } from 'fp-ts/function';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as Sep from 'fp-ts/Separated';
import { useTranslation } from 'react-i18next';
import { LevelBadgeList, OtherBadgeList } from './badge-list';
import BadgesLoader from './badges-loader';
import { useGetLevelsAndBadges } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useProps = function useProps() {
  return {
    data: useGetLevelsAndBadges(),
    t: useTranslation().t
  };
};

var TitleWrapper = function TitleWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      mt: 1,
      px: 3
    },
    "data-element": "Box",
    "data-component": "TitleWrapper",
    "data-source-file": "index.tsx",
    children: children
  });
};

var isLevelBadgeProgression = function isLevelBadgeProgression(badgeProgression) {
  var _badgeProgression$bad;

  return !!((_badgeProgression$bad = badgeProgression.badge.level) !== null && _badgeProgression$bad !== void 0 && _badgeProgression$bad.id);
};

var AVERAGE_BLOCK_HEIGHT = 670;
export var PureBadgesProgress = function PureBadgesProgress(_ref2) {
  var data = _ref2.data,
      t = _ref2.t;
  return pipe(data, DE.refreshFold(function () {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        height: AVERAGE_BLOCK_HEIGHT
      }
    });
  }, function () {
    return /*#__PURE__*/_jsx(TitleWrapper, {
      children: /*#__PURE__*/_jsx(BadgesLoader, {})
    });
  }, flow(logQueryError, constNull), function (_ref3) {
    var levels = _ref3.levels,
        badgeProgressions = _ref3.badgeProgressions;
    return pipe(badgeProgressions, A.partition(isLevelBadgeProgression), Sep.map(NEA.groupBy(function (bp) {
      return bp.badge.level.id;
    })), function (_ref4) {
      var leveledBadgeProgressions = _ref4.right,
          otherBadgeProgressions = _ref4.left;
      return /*#__PURE__*/_jsxs(TitleWrapper, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "body1",
          sx: {
            mt: 1,
            mb: 2,
            color: function color(theme) {
              return theme.palette.text.secondary;
            }
          },
          children: t('Below are the badges and levels that you can achieve. Click a badge to see more details.')
        }), levels.map(function (levelProgress) {
          var _leveledBadgeProgress;

          return /*#__PURE__*/_jsx(LevelBadgeList, {
            levelProgress: levelProgress,
            badgeProgressions: (_leveledBadgeProgress = leveledBadgeProgressions[levelProgress.level.id]) !== null && _leveledBadgeProgress !== void 0 ? _leveledBadgeProgress : []
          }, levelProgress.level.id);
        }), otherBadgeProgressions.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Divider, {
            sx: {
              my: 3
            }
          }), /*#__PURE__*/_jsx(OtherBadgeList, {
            badgeProgressions: otherBadgeProgressions
          })]
        }) : null]
      });
    });
  }));
};
export var BadgesProgress = flow(useProps, PureBadgesProgress);
export { BadgesModalButton, BadgesProgressModal } from './modal';